import React from 'react'
import styled, { css } from 'styled-components'

export default ({ z = '1', debug = false, xsTop, xsBottom, mdTop, mdBottom, lgTop, lgBottom, ...props }) => {
  return (
    <Container
      z={z}
      debug={debug}
      xsTop={xsTop}
      xsBottom={xsBottom}
      mdTop={mdTop}
      mdBottom={mdBottom}
      lgTop={lgTop}
      lgBottom={lgBottom}
      {...props}>
      <svg fill="none" viewBox="0 0 858 26" {...props}>
        <path
          fill="url(#prefix__paint0_linear)"
          fillRule="evenodd"
          d="M596.097.7l37.321 20.03 37.264-20 37.263 20 37.264-20 37.264 20 37.263-20 38.21 20.508-1.892 3.524L819.736 5.27l-37.263 20-37.264-20-37.264 20-37.263-20-37.264 20L596.21 5.3l-.462.276a903.3 903.3 0 01-3.82 2.27 819.31 819.31 0 01-11.876 6.893c-4.41 2.505-8.97 5.023-12.698 6.919-1.86.946-3.542 1.752-4.906 2.326-.681.287-1.312.528-1.864.7-.505.158-1.117.316-1.693.316-.599 0-1.196-.168-1.679-.337a15.945 15.945 0 01-1.685-.726c-1.193-.585-2.628-1.401-4.203-2.348-2.264-1.36-4.916-3.052-7.684-4.817-1.079-.688-2.175-1.387-3.273-2.082-3.946-2.5-7.937-4.964-11.377-6.8-1.721-.92-3.265-1.66-4.571-2.166C523.068 5.2 522.152 5 521.627 5c-.501 0-1.315.187-2.499.697-1.149.494-2.489 1.222-3.993 2.137-2.595 1.578-5.519 3.611-8.6 5.754l-1.519 1.056c-3.598 2.495-7.353 5.05-10.828 6.98-3.394 1.884-6.865 3.376-9.824 3.376-3.004 0-6.202-1.528-9.251-3.427-2.766-1.723-5.707-3.949-8.628-6.16l-1.08-.817c-3.32-2.506-6.607-4.93-9.782-6.732C452.422 6.048 449.567 5 447.1 5c-8.204 0-12.328 4.353-17.042 9.37l-.029.03c-4.694 4.995-9.961 10.6-20.185 10.6-10.182 0-15.365-5.565-19.998-10.54l-.09-.097c-4.657-5-8.788-9.363-17.167-9.363-8.38 0-12.51 4.363-17.169 9.363l-.089.096C350.697 19.434 345.512 25 335.325 25c-10.182 0-15.365-5.565-19.998-10.54l-.09-.097c-4.658-5-8.788-9.363-17.168-9.363-8.379 0-12.51 4.363-17.168 9.363l-.089.096C276.177 19.434 270.993 25 260.806 25c-10.182 0-15.365-5.565-19.998-10.54l-.091-.097C236.06 9.363 231.93 5 223.55 5c-8.375 0-12.504 4.362-17.161 9.363l-.088.094C201.667 19.433 196.482 25 186.294 25s-15.372-5.567-20.007-10.543l-.087-.094c-4.658-5-8.786-9.363-17.161-9.363-8.38 0-12.51 4.363-17.169 9.363l-.089.096C127.147 19.434 121.962 25 111.775 25c-10.182 0-15.365-5.565-19.998-10.54l-.09-.097C87.029 9.363 82.899 5 74.519 5c-8.38 0-12.51 4.363-17.168 9.363l-.089.096C52.627 19.434 47.442 25 37.256 25c-10.183 0-15.365-5.565-19.998-10.54l-.09-.097C12.51 9.363 8.38 5 0 5V1c10.188 0 15.373 5.567 20.007 10.543l.087.094c4.658 5 8.786 9.363 17.162 9.363 8.38 0 12.51-4.363 17.168-9.363l.089-.096c4.635-4.975 9.82-10.54 20.006-10.54 10.188 0 15.373 5.566 20.007 10.542l.088.094c4.657 5 8.786 9.363 17.161 9.363 8.38 0 12.51-4.363 17.168-9.363l.089-.096c4.635-4.975 9.82-10.54 20.007-10.54 10.182 0 15.365 5.564 19.998 10.539l.09.097c4.657 5 8.788 9.363 17.167 9.363 8.38 0 12.51-4.363 17.168-9.363l.09-.097C208.185 6.565 213.368 1 223.55 1c10.188 0 15.373 5.567 20.007 10.543l.087.094c4.658 5 8.786 9.363 17.162 9.363 8.379 0 12.51-4.363 17.168-9.363l.089-.095C282.698 6.566 287.882 1 298.069 1c10.188 0 15.373 5.567 20.007 10.543l.088.094c4.657 5 8.786 9.363 17.161 9.363 8.38 0 12.51-4.363 17.168-9.363l.089-.096c4.635-4.975 9.82-10.54 20.007-10.54 10.188 0 15.373 5.566 20.007 10.542l.087.094c4.658 5 8.786 9.363 17.161 9.363 8.387 0 12.603-4.372 17.299-9.37l.161-.171C431.945 6.519 437.13 1 447.1 1c3.505 0 7.092 1.453 10.498 3.386 3.432 1.948 6.913 4.524 10.217 7.018l1.078.815c2.949 2.232 5.735 4.34 8.334 5.958 2.972 1.851 5.34 2.823 7.137 2.823 1.842 0 4.522-1.008 7.882-2.873 3.278-1.82 6.88-4.266 10.491-6.77l1.499-1.042c3.07-2.136 6.112-4.252 8.82-5.899 1.579-.96 3.098-1.794 4.491-2.394 1.359-.584 2.768-1.022 4.08-1.022 1.289 0 2.769.425 4.238.995 1.515.587 3.217 1.41 5.008 2.366 3.585 1.913 7.686 4.449 11.635 6.95 1.129.714 2.244 1.426 3.333 2.12 2.748 1.753 5.328 3.398 7.544 4.73 1.545.928 2.864 1.675 3.902 2.184.52.255.935.433 1.25.543.202.071.317.098.362.107.053-.01.207-.04.491-.128.385-.12.888-.31 1.507-.57 1.235-.52 2.818-1.276 4.644-2.204 3.645-1.855 8.143-4.337 12.535-6.832a815.974 815.974 0 0011.817-6.858 923.09 923.09 0 004.858-2.893l.347-.208.018-.011.004-.003h.001L596.155 3l-1.034-1.712.976-.589z"
          clipRule="evenodd"
        />
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={857}
            x2={-10.316}
            y1={13.002}
            y2={13.002}
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#FDB90E" />
            <stop offset={1} stopColor="#FDA1C4" />
          </linearGradient>
        </defs>
      </svg>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  z-index: ${({ z }) => (z ? z : 1)}!important;
  svg {
    width: 100%;
  }
  ${({ debug }) =>
    debug &&
    css`
      border: ${`2px dashed ${debug}`};
    `}

  ${({ xsBottom }) =>
    xsBottom &&
    css`
      padding-bottom: ${xsBottom};
    `}

  ${({ xsTop }) =>
    xsTop &&
    css`
      padding-top: ${xsTop};
    `}

  ${({ mdBottom }) =>
    mdBottom &&
    css`
      @media (min-width: 720px) {
        padding-bottom: ${mdBottom};
      }
    `}

    ${({ mdTop }) =>
      mdTop &&
      css`
        @media (min-width: 720px) {
          padding-top: ${mdTop};
        }
      `}

  ${({ lgBottom }) =>
    lgBottom &&
    css`
      @media (min-width: 1025px) {
        padding-bottom: ${lgBottom};
      }
    `}

    ${({ lgTop }) =>
      lgTop &&
      css`
        @media (min-width: 1025px) {
          padding-top: ${lgTop};
        }
      `}
`
